import Layout from '../component/Layout/Layout'
import { useCelebrityAPI } from '../hooks/useAllCategoryData';
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';
const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
export default function Celebrity() {

     const { isLoading, error, data } = useCelebrityAPI();
     if (error) return <div>{error.message}</div>;
    
  return (
    <Layout title="Celebrity : Chaashni by Maansi & Ketan" description="Chaashni Couture: Celebrity" > 
    {isLoading && (
        <div className='loading-div'><span>Loading...</span></div>
    )}
     {data?.celebrity?.map((e, i) => ( 
        <div className="site-content-wrap static-page carousel-box celebrity-page-wrap" key={i}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="sustom-heading-h1">{e.instagram_url? (<Link to={e.instagram_url} target="_blank"><i className="fa-brands fa-instagram"></i> {e.name} </Link>):(`${e.name}`)}{/* <small><Link to={e.instagram_url} target="_blank"><i className="fa-brands fa-instagram"></i> <span>{e.instagram_url}</span></Link></small> */} </h1>
                        <div className={`content-box Celebrity`}>                         
                            {JSON.parse(e.image_gallery).length > 0 && (                                    
                              <Carousel showDots={false}
                                responsive={responsive}                                     
                                infinite={true}                                      
                                autoPlaySpeed={1000}                                      
                                transitionDuration={500}
                                containerClass="carousel-container"                                      
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-0-px">
                                      {JSON.parse(e.image_gallery)?.map((item,i) => (
                                        <div className="testi-timg-gallery" key={i}>
                                          <img
                                            src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/celebrity_gallery/${item}`}
                                            alt={item}
                                            width={612}
                                            height={918}                                   
                                          /></div> 
                                      ))}
                              </Carousel>                                               
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
         ))}        
    </Layout>
  )
}